module.exports = __webpack_public_path__ + "static/media/dollarSign.77a60f3d.svg";